/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isEmpty } from 'lodash';

// Components
import Badge from 'shared/ui/components/Badge.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import DatetimePicker from 'shared/ui/components/form-components/pickers/DatetimePicker.vue';
import Dialog from 'shared/ui/components/modals/DialogComponent.vue';
import EmailTemplatePicker from 'shared/ui/components/form-components/pickers/EmailTemplatePicker.vue';
import InlineDatePicker from 'shared/ui/components/form-components/pickers/InlineDatePicker.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import TargetingControl from 'shared/ui/components/form-components/TargetingControl.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

/**
 * Component for selecting the template and other options for the emails we're about to send.
 *
 * @vue-prop {Object} event the event for which mails are showing
 * @vue-prop {Array} recipientsExtIds the users' fp_ext_ids we're about to send emails to
 *
 * @category ui.components.wizards
 * @exports EventProgress
 */
const __vue_script__ = {
    name: 'SendEmailsModal',

    components: {
        Badge,
        BaseSelect,
        DatetimePicker,
        EmailTemplatePicker,
        InlineDatePicker,
        LoaderButton,
        TargetingControl,
        Toggler
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        recipientsExtIds: {
            type: Array,
            required: true
        },

        onSuccess: {
            type: Function,
            default: () => {}
        }
    },

    data() {
        return {
            additionalTargetingFields: [{
                label: this.$i18n.t('users.email_modal.invited_targeting'),
                property: '_target_invited_to_event',
                name: '_target_invited_to_event',
                kind: 'boolean',
            }],
            loading: false,
            schedule: false,
            scheduledEmails: [],
            scheduleTime: null,
            selectedCluster: null,
            selectedTemplate: null,
            targeting: null,
            templates: [],
            clusters: [
                { value: 'all', label: this.$i18n.t('users.email_modal.targets.all') },
                { value: 'pending', label: this.$i18n.t('users.email_modal.targets.pending') },
                { value: 'not-invited', label: this.$i18n.t('users.email_modal.targets.not_invited') },
                { value: 'active', label: this.$i18n.t('users.email_modal.targets.active') },
                { value: 'targeted', label: this.$i18n.t('users.email_modal.targets.targeted') }
            ]
        };
    },

    computed: {
        /** @returns {Boolean} */
        hasCustomTargeting() {
            return this.selectedCluster?.value === 'targeted';
        },

        /** @returns {Date} */
        minStartDate() {
            const time = this.$utils.time.now().add(5, 'minutes');
            return this.$utils.time.transformTzTimeToLocal(time, this.event.timezone).toDate();
        },

        /** @returns {Object[]} */
        sameTimeScheduledEmails() {
            return this.scheduledEmails.filter(mailing => this.$utils.time.dateIsEqual(this.scheduleTime, mailing.scheduled));
        },

        /** @returns {boolean} */
        showNavigate() {
            return !this.event.is_content_hub && this.scheduledEmails.length > 0;
        },

        /** @returns {boolean} */
        submitDisabled() {
            const noTarget = !this.recipientsExtIds.length && isEmpty(this.selectedCluster);
            const emptyTemplate = isEmpty(this.selectedTemplate);
            const notProperlyScheduled = this.schedule && (!this.scheduleTime || this.$utils.time.dateIsBefore(this.scheduleTime, this.minStartDate));
            const { targets = [], exceptions = [] } = this.targeting || {};
            const noCustom = this.hasCustomTargeting && !targets.length && !exceptions.length;
            return emptyTemplate || noTarget || notProperlyScheduled || noCustom;
        },

        /** @returns {string} */
        openDropdownDirection() {
            return get(this, 'selectedCluster.value') === 'targeted' ? 'above' : 'below';
        }
    },

    watch: {
        schedule() {
            this.scheduleTime = this.minStartDate;
        },

        hasCustomTargeting(value) {
            const { targets = [], exceptions = [] } = this.targeting || {};

            if (value && !targets.length && !exceptions.length) {
                this.$refs['targeting']?.focus();
            }
        }
    },

    async created() {
        try {
            if (this.$services.blueprint.isModuleInstalled('registration')) {
                const { settings } = await this.$services.pax.getRegistrationConfig(this.event.id);
                if (['private', 'hybrid'].includes(settings.access_type)) {
                    const rsvp = { value: 'rsvp-not-invited', label: this.$i18n.t('users.email_modal.targets.rsvp_not_invited') };
                    this.clusters.splice(this.clusters.length - 1, 0, rsvp);
                }
            }
        } catch (error) {
            console.warn('[SendEmailsModal] Could not properly initialize the targeting clusters for RSVP', error.message);
        }
    },

    async mounted() {
        const templates = await this.$services.emails.getEmailTemplates(this.event.id, true);

        this.templates = templates;

        const scheduledEmails = await this.$services.emails.getScheduledEmailsTimestamps(this.event.id);
        this.scheduledEmails = scheduledEmails.map(mailing => {
            const template = templates.find(template => template._id === mailing.template_id);
            const localeSchedule = this.$utils.time.transformTzTimeToLocal(this.$utils.time.unixToDate(mailing.scheduled_at), this.event.timezone);
            return {
                displayString: `${this.$utils.time.dateToFormat(localeSchedule, this.$const.DEFAULT_DATETIME_FORMAT)} (${template.template_name || template.subject})`,
                scheduled: localeSchedule
            };
        });
    },

    methods: {
        /**
         * Check wether we need to display the go to production modal
         * @returns {Boolean}
         */
        checkCount(targetCount) {
            return this.event.stage === 'production' || targetCount < 2;
        },

        /**
         * Check wether the event is a test event
         * @returns {Boolean}
         */
        checkTestEvent() {
            return this.event.stage === 'sandbox' ;
        },

        /**
         * Handling time change within the date picker
         * @param {Date} date
         */
        dateChange(date) {
            if (this.$utils.time.dateIsBefore(date, this.minStartDate)) {
                this.scheduleTime = this.minStartDate;
            }
        },

        /**
         * Get the pax count for the current target
         * @returns {Promise<Number>}
         */
        async getPaxCount() {
            try {
                this.loading = true;
                const targets = this.hasCustomTargeting ? this.targeting : this.selectedCluster.value;
                return await this.$services.emails.getAffectedPaxCount(this.event.id, targets);
            } catch (error) {
                console.error('[SendEmailsModal] Could not fetch pax count emails', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('contents.messages.email_pax_error').toString(),
                    type: 'error',
                    duration: 5000
                });
            } finally {
                this.loading = false;
            }
        },

        navigateToEmails() {
            if (this.event.is_content_hub) {
                return;
            }
            this.$emit('close');
            // Do note that for now this will only work for events as such a page doesn't exist for content hubs
            const route = this.$services.blueprint.getControllerByName('emailing', 'mailing-docs').route.replace(':eventId', this.event.id);
            window.open(route, '_blank');
        },

        /**
         * Actually sending emails.
         */
        async sendEmails() {
            try {
                const selectedCluster = this.selectedCluster && !this.hasCustomTargeting ? this.selectedCluster.value : undefined;
                const scheduleTime = this.schedule ? this.$utils.time.dateToUnix(this.$utils.time.transformLocalTimeToTz(this.scheduleTime, this.event.timezone)) : undefined;
                const data = await this.$services.emails.sendEmails(
                    this.event.id,
                    this.selectedTemplate,
                    selectedCluster,
                    this.targeting,
                    this.recipientsExtIds,
                    scheduleTime
                );

                const recipCount = this.recipientsExtIds.length;
                const emailAction = this.schedule ? 'scheduled' : 'sent';
                const text = this.recipientsExtIds.length
                    ? this.$i18n.tc(`contents.messages.email_${emailAction}`, recipCount, [recipCount]).toString()
                    : this.$i18n.tc(`contents.messages.email_${emailAction}_to_users`, this.selectedCluster.value, [this.selectedCluster.value]).toString();

                this.$notify({
                    group: 'flashes',
                    text,
                    type: 'success',
                    duration: 5000
                });

                if (typeof this.onSuccess === 'function') {
                    this.onSuccess(data);
                }

            } catch (error) {
                console.error('[SendEmailsModal] Could not send emails', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('contents.messages.email_send_error').toString(),
                    type: 'error',
                    duration: 5000
                });
            } finally {
                this.loading = false;
                this.$emit('close');
            }
        },

        /**
         * Process that's started when clicking on "send"
         */
        async startSendingEmails() {
            this.loading = true;

            if (!this.selectedCluster) {
                if (this.checkCount(this.recipientsExtIds.length)) {
                    this.sendEmails();
                } else {
                    if (this.checkTestEvent()) {
                        this.showTestEventModal();
                    } else {
                        this.showProductionModal();
                    }
                }
                return;
            }

            const paxCount = await this.getPaxCount();

            if (typeof paxCount !== 'undefined') {
                if (this.checkCount(paxCount)) {
                    this.showConfirmationModal(paxCount);
                } else {
                    if (this.checkTestEvent()) {
                        this.showTestEventModal();
                    } else {
                        this.showProductionModal(paxCount);
                    }
                }
            }
        },

        /**
         * Show a modal to confirm things when you want to send an email to more than one person
         */
        showConfirmationModal(paxCount) {
            this.$modal.show(
                Dialog,
                {
                    text: this.$i18n.t('users.email_modal.confirmation_body', [paxCount, this.selectedCluster.label]),
                    title: this.$i18n.t('general.confirm'),
                    buttons: [
                        {
                            title: this.$i18n.t('general.cancel'),
                            default: true,
                            handler: () => {
                                this.loading = false;
                            },
                            class: 'btn',
                            closeOnClick: true
                        },
                        {
                            title: this.$i18n.t('general.proceed'),
                            handler: () => {
                                this.sendEmails();
                            },
                            class: 'btn btn-primary',
                            closeOnClick: true
                        }
                    ]
                },
                {
                    height: 'auto',
                    clickToClose: false
                }
            );
        },

        /**
         * Shows a modal to warn the user that the event is in pre-production when sending a mail to more than one person.
         */
        showProductionModal(paxCount) {
            this.loading = false;
            this.$modal.show(
                Dialog,
                {
                    text: this.$i18n.t('users.email_modal.no_production.body'),
                    title: this.$i18n.t('users.email_modal.no_production.title'),
                    buttons: [
                        {
                            title: this.$i18n.t('general.cancel'),
                            default: true,
                            class: 'btn',
                            handler: () => {
                            },
                            closeOnClick: true
                        },
                        {
                            title: this.$i18n.t('general.proceed'),
                            handler: () => {
                                if (paxCount) {
                                    this.showConfirmationModal(paxCount);
                                } else {
                                    this.sendEmails();
                                }
                            },
                            class: 'btn btn-primary',
                            closeOnClick: true
                        }
                    ]
                },
                {
                    height: 'auto',
                    clickToClose: false
                }
            );
        },

        /**
         * Shows a modal to prompt the user to change the event to production to send email to more than one person.
         */
        showTestEventModal() {
            this.loading = false;
            this.$modal.show(
                Dialog,
                {
                    text: this.$i18n.t('users.email_modal.no_production.body_test_event'),
                    title: this.$i18n.t('users.email_modal.no_production.title_test_event'),
                    buttons: [
                        {
                            title: this.$i18n.t('general.cancel'),
                            default: true,
                            class: 'btn',
                            handler: () => {
                            },
                            closeOnClick: true
                        },
                        {
                            title: this.$i18n.t('users.email_modal.no_production.go_to_settings'),
                            handler: () => {
                                this.$emit('close');
                                const route = this.event.is_content_hub ? `/${this.event.id}/settings/general` : `/event/${this.event.id}/settings`;
                                this.$router.push(route);
                            },
                            class: 'btn btn-primary',
                            closeOnClick: true
                        }
                    ]
                },
                {
                    height: 'auto',
                    clickToClose: false
                }
            );
        },

        /**
         * Handling time change within the time picker
         * @param {Date} date
         * @param {String} type
         */
        timeChange(date, type) {
            if (type === 'minute') {
                this.$refs.timePicker.close();
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-emails-modal modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function () { return _vm.$emit('close'); }}}),_c('h3',[_vm._v(_vm._s(_vm.$t('users.email_modal.title')))])]),_c('div',{staticClass:"modal-body"},[(!_vm.recipientsExtIds.length)?[_c('base-select',{staticClass:"target",attrs:{"name":"target","options":_vm.clusters,"label":_vm.$t('users.email_modal.target'),"placeholder":_vm.$t('users.email_modal.target_placeholder')},model:{value:(_vm.selectedCluster),callback:function ($$v) {_vm.selectedCluster=$$v},expression:"selectedCluster"}})]:_vm._e(),_c('targeting-control',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasCustomTargeting),expression:"hasCustomTargeting"}],ref:"targeting",attrs:{"name":"targeting","label":_vm.$t('emailing.targeting.label'),"hint":_vm.$t('emailing.targeting.intro'),"visible-to-label":_vm.$t('targeting.conditions_editor.emailing.send_to'),"hidden-to-label":_vm.$t('targeting.conditions_editor.emailing.do_not_send_to'),"visible-to-desc":_vm.$t('emailing.targeting.text_for_visible_to'),"hidden-to-desc":_vm.$t('emailing.targeting.text_for_hidden_to'),"target-label":_vm.$t('emailing.targeting.will_send_to'),"event-id":_vm.event.id,"additional-fields":_vm.additionalTargetingFields},model:{value:(_vm.targeting),callback:function ($$v) {_vm.targeting=$$v},expression:"targeting"}}),_c('email-template-picker',{attrs:{"event-id":_vm.event.id,"name":"template","label":_vm.$t('users.email_modal.template'),"placeholder":_vm.$t('users.email_modal.template_placeholder'),"templates":_vm.templates,"open-direction":_vm.openDropdownDirection},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}}),(_vm.recipientsExtIds.length > 1)?_c('p',[_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.recipientsExtIds.length))]),_c('span',[_vm._v(_vm._s(_vm.$tc('users.email_modal.selected', _vm.recipientsExtIds.length)))])],1):_vm._e(),_c('toggler',{staticClass:"schedule-toggler",attrs:{"name":"schedule","on-label":"users.email_modal.schedule_toggler","off-label":"users.email_modal.schedule_toggler"},model:{value:(_vm.schedule),callback:function ($$v) {_vm.schedule=$$v},expression:"schedule"}}),(_vm.schedule)?_c('div',{staticClass:"schedule-time-pickers"},[_c('inline-date-picker',{attrs:{"name":"send_time","format":_vm.$const.DEFAULT_DATETIME_FORMAT,"not-before":_vm.minStartDate,"clearable":true},on:{"change":_vm.dateChange},model:{value:(_vm.scheduleTime),callback:function ($$v) {_vm.scheduleTime=$$v},expression:"scheduleTime"}}),_c('datetime-picker',{ref:"timePicker",attrs:{"label":_vm.$t('users.email_modal.time'),"type":"time","show-second":false,"minute-step":5,"name":"send_hour","format":_vm.$const.DEFAULT_TIME_FORMAT,"not-before":_vm.minStartDate,"clearable":true,"hint":_vm.$t('users.email_modal.workspace_timezone', [this.event.timezone]),"popup-class":"timepicker-scheduled-email","only-update-time":true},on:{"change":_vm.timeChange},model:{value:(_vm.scheduleTime),callback:function ($$v) {_vm.scheduleTime=$$v},expression:"scheduleTime"}})],1):_vm._e(),(_vm.sameTimeScheduledEmails.length)?_c('div',{staticClass:"schedule-warning"},[_c('span',[_vm._v(_vm._s(_vm.$t('users.email_modal.other_email')))]),_c('ul',_vm._l((_vm.sameTimeScheduledEmails),function(mailing){return _c('li',[_vm._v(_vm._s(mailing.displayString))])}),0)]):_vm._e()],2),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"footer-actions"},[(_vm.showNavigate)?_c('a',{staticClass:"email-navigation",on:{"click":_vm.navigateToEmails}},[_vm._v(_vm._s(_vm.$t('users.email_modal.navigate_to_scheduled', [_vm.scheduledEmails.length])))]):_vm._e(),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('loader-button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.submitDisabled,"status":_vm.loading},on:{"click":function($event){return _vm.startSendingEmails()}}},[_vm._v(_vm._s(_vm.$t(("users.actions." + (_vm.schedule ? 'schedule' : 'send')))))])],1)])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SendEmailsModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__